import React from "react";
import "@styles/pages/Home/EarnEveryDollarFlexRedeem.scss";
import { Trans, useTranslation } from "react-i18next";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { delay, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { gaEvent } from "@utils/gaEvent";

const EarnEveryDollarFlexRedeem = () => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === "hk";
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  return (
    <Box className="earn-every-dollar-flex-redeem-container">
      <Typography className="title">
        <Trans i18nKey="home:earn_every_dollar" />
      </Typography>

      <img
        className="black-image"
        onClick={() => {
          gaEvent("clubs_homepage", "earn_points", "earn_points");
          navigate("/earn");
        }}
        src={`${process.env.PUBLIC_URL}/assets/images/home/${
          isMobile
            ? isChinese
              ? "earn_every_dollar_hk_mobile.png"
              : "earn_every_dollar_hk_en_mobile.png"
            : isChinese
            ? "earn_every_dollar_hk.png"
            : "earn_every_dollar_hk_en.png"
        }`}
        alt="earn_every_dollar"
      ></img>
      <Typography className="title">
        <Trans i18nKey="home:flexi_redeem" />
      </Typography>
      <img
        className="black-image"
        onClick={() => {
          gaEvent("clubs_homepage", "redeem_rewards", "redeem_rewards_1");
          navigate("/redeem");
        }}
        src={`${process.env.PUBLIC_URL}/assets/images/home/${
          isMobile
            ? isChinese
              ? "flexi_redeem_hk_01_mobile.png"
              : "flexi_redeem_hk_en_01_mobile.png"
            : isChinese
            ? "flexi_redeem_hk_01.png"
            : "flexi_redeem_hk_en_01.png"
        }`}
        alt="earn_every_dollar"
      ></img>
      <img
        className="black-image"
        onClick={() => {
          gaEvent("clubs_homepage", "redeem_rewards", "redeem_rewards_2");
          navigate("/redeem");
        }}
        src={`${process.env.PUBLIC_URL}/assets/images/home/${
          isMobile
            ? isChinese
              ? "flexi_redeem_hk_02_mobile.png"
              : "flexi_redeem_hk_en_02_mobile.png"
            : isChinese
            ? "flexi_redeem_hk_02.png"
            : "flexi_redeem_hk_en_02.png"
        }`}
        alt="earn_every_dollar"
      ></img>
    </Box>
  );
};

export default EarnEveryDollarFlexRedeem;
